




import { Component, Vue } from 'vue-property-decorator';
import Footbowl from '@/components/game/footbowl/Footbowl.vue';

@Component({
  components: {
    Footbowl,
  },
})
export default class FootbowlGame extends Vue {}
